import "../../../Index.scss";
import { Skeleton } from "primereact/skeleton";
import "./SearchResultShimmer.scss"

export const SearchResultShimmer = () => {
  return (
    <div className="shimmer_ui">
      {
        [...Array(10)].map((e, i) =>
          <div key={`SearchResultShiimer${i}`} className="shimmer_rows mb-4"> 
            <Skeleton width="14rem" height="1.5rem" className="mb-2"></Skeleton>
            <Skeleton height="2rem" width="20rem" className="mb-2"></Skeleton>
            <Skeleton height="4rem"></Skeleton>
          </div>
        )
      }
    </div>
  )
}

export default SearchResultShimmer


